module.exports = __webpack_public_path__ + "static/img/Two of Wands.3ee01e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Two of Wands.jpg
// module id = 1332
// module chunks = 0